/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateViewResponse {
    getFixupPrototypeFunction() { return TemplateViewResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateViewResponse>): TemplateViewResponse {
        let obj = Object.assign(new TemplateViewResponse(), model);
        TemplateViewResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateViewResponse>): TemplateViewResponse {
        if (!model) return null;
        return TemplateViewResponse.newInstance(<TemplateViewResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateViewResponse) {
        if (!obj) return;

        models.TemplateViewResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateViewResponse): boolean {
        Object.setPrototypeOf(obj, TemplateViewResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Unique Id of the template
     */
    template_id: string;

    /**
     * Service(s) associated with the template, for example, AWS, AzureRM, Openstack., etc
     */
    services: Array<string>;

    /**
     * Name of the template
     */
    template_name: string;

    /**
     * Raw content of the template which is usually in YAML or JSON format
     */
    content: string;

    /**
     * Template content source (git, file)
     */
    content_type: string;

    /**
     * Git project URL when the content type is git required only in case of content type git
     */
    content_url: string;

    /**
     * Details about content like its data,filename
     */
    content_files: string;

    /**
     * Usage of template
     */
    description: string;

    resources: string;

    resource_type: string;

    /**
     * Status of the template[active/inactive]. Only active templates can be executed
     */
    status: string;

    /**
     * Type of the template like Cloud, Monitoring, Orchestration., etc
     */
    type: Array<string>;

    /**
     * DSL of the template
     */
    dsl: string;

    /**
     * Classification of the template
     */
    classification: Array<string>;

    /**
     * Scope of the template [Account,Tenant,Private]
     */
    scope: string;

    /**
     * Name of the user who created the template.
     */
    created_by: string;

    /**
     * Template creation time
     */
    created_at: string;

    /**
     * Name of the user who updated the templated.
     */
    updated_by: string;

    /**
     * Template updated time
     */
    updated_at: string;

}
